import Splide from '@splidejs/splide';
theme.Splide = Splide; 